import { useLocation, useParams } from 'react-router-dom'

import type { KyrgyzstanGalleryRouteState } from 'entities/kyrgyzstan/lib'
import { ImageGalleryWrapper } from 'entities/kyrgyzstan/ui/image-gallery-wrapper'

const KyrgyzstanOptionDetailGalleryImagePage = () => {
  const { id, imageIndex } = useParams<{ id: string; imageIndex: string }>()
  const { state } = useLocation()

  const gallery = (state as KyrgyzstanGalleryRouteState | null)?.gallery
  const data = gallery?.realtyId === id ? gallery : null

  const initialIndex = Number(imageIndex) || 0

  return (
    <ImageGalleryWrapper
      images={data?.images || []}
      title={data?.title || ''}
      initialIndex={initialIndex}
      isLoading={false}
      error={null}
    />
  )
}

export default KyrgyzstanOptionDetailGalleryImagePage
